"use client";

import { useQuery } from "@tanstack/react-query";
import { InferAttributes } from "sequelize";
import { Users } from "@/database/models/users";

export function useUser() {
  const { data, isLoading, error, refetch } =
    useQuery<InferAttributes<Users> | null>({
      queryKey: ["user"],
      queryFn: async () => {
        const response = await fetch("/api/user");
        if (!response.ok) throw new Error("Failed to fetch user");
        return response.json();
      },
      refetchInterval: 5000, // Auto-refresh every 5 seconds
      staleTime: 5000,
    });

  return {
    user: data,
    isLoading,
    error,
    refetch,
  };
}
